import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberTitle',
  standalone: true,
})
export class NumberTitlePipe implements PipeTransform {
  transform(numberTitle: number): string {
    return numberTitle < 10 && numberTitle >= 0 ? '0' + numberTitle : numberTitle.toString();
  }
}
